import { CategoriaNegocioEntity } from "src/app/pages/_user/categoria-negocio/categoria-negocio.entity";

export const autoCompleteCategoriaNegocioOutPut = (value: string | number, row: CategoriaNegocioEntity) => {
  if (!row) {
    return { nomeCategoria: value }
  }
  return { categoriaId: row.id }
}
